import { showConfirmationDialog } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { navigateTo, createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";

export async function showIncorrectWebDavCredentialsDialog(onCancel?: () => void): Promise<void> {
	const result: TryResult<void> = await showConfirmationDialog(
		{
			title: localize("_CannotAccessFileServers"),
			message: localize("_UsernameOrPasswordIncorrectOrNoPermissionsOrFileserversDontExist"),
			confirmText: localize("_UpdateCredentials"),
			cancelText: localize("_Close"),
			trackingId: "incorrect-web-dav-credentials-dialog"
		}
	);

	if (!result.wasSuccessful) {
		if (onCancel) {
			onCancel();
		}

		return;
	}

	navigateTo(createUrlRelativeToEnvironment("/IntegrationCredentials/EditFileServerCredentials"));
}
